"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportedNutrients = void 0;
const Tags_1 = require("./../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("./../CardType");
const SelectCard_1 = require("../../inputs/SelectCard");
const ResourceType_1 = require("../../ResourceType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
class ImportedNutrients extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.IMPORTED_NUTRIENTS,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SPACE],
            cost: 14,
            metadata: {
                cardNumber: 'X22',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.plants(4).digit.nbsp().microbes(4).digit.asterix();
                }),
                description: 'Gain 4 plants and add 4 microbes to ANOTHER CARD.',
            },
        });
    }
    play(player) {
        player.plants += 4;
        const microbeCards = player.getResourceCards(ResourceType_1.ResourceType.MICROBE);
        if (microbeCards.length === 1) {
            player.addResourceTo(microbeCards[0], { qty: 4, log: true });
            return undefined;
        }
        else if (microbeCards.length > 1) {
            return new SelectCard_1.SelectCard('Select card to add 4 microbes', 'Add microbes', microbeCards, (foundCards) => {
                player.addResourceTo(foundCards[0], { qty: 4, log: true });
                return undefined;
            });
        }
        return undefined;
    }
}
exports.ImportedNutrients = ImportedNutrients;
//# sourceMappingURL=ImportedNutrients.js.map